import React from 'react';
import { TextAlignments } from '@/constants/TextAlignments';
import styles from './PageCTA.module.scss';
import { Title } from '../Title';
import { Text } from '../Text';
import { FunnelButton } from '../FunnelButton';

export const PageCTA = ({
  title = <>You’ve got nothing to lose except your home&nbsp;loan!</>,
  description = 'Start saving a whole lotta time and money',
  ctaLabel = 'Get Started',
}: {
  title?: React.ReactNode | string;
  description?: React.ReactNode | React.ReactNode[];
  ctaUrl?: string;
  ctaLabel?: string;
}) => (
  <section className={styles.section}>
    <div className={styles.container}>
      <div className={styles.title}>
        <Title size="l" desktopAlignment={TextAlignments.CENTER} mobileAlignment={TextAlignments.CENTER}>
          <h2>{title}</h2>
        </Title>
      </div>
      <div className={styles.description}>
        <Text size="medium" desktopAlignment={TextAlignments.CENTER} mobileAlignment={TextAlignments.CENTER}>
          <p>{description}</p>
        </Text>
      </div>
      <div className={styles.actions}>
        <FunnelButton size="large">{ctaLabel}</FunnelButton>
      </div>
    </div>
  </section>
);
